import React, { useEffect, useState } from 'react';
import { useGameSettings } from './slotData';

const WinResult = ({ winAmount, setSoundEffectFile }) => {
  const { totalWinAudioUrl } = useGameSettings()
  const [currentAmount, setCurrentAmount] = useState(0);

  useEffect(() => {
    if (winAmount > 0) {
      let start = 0;
      const duration = 1500; // 1.5 seconds for full count-up
      const interval = 20; // Faster update speed
      const steps = Math.ceil(duration / interval);
      const increment = winAmount / steps;

      const counter = setInterval(() => {
        start += increment;
        if (start >= winAmount) {
          setCurrentAmount(winAmount.toFixed(2)); // Show two decimal places
          clearInterval(counter);
        } else {
          setCurrentAmount(start.toFixed(2)); // Show decimals in animation
        }
      }, interval);

      return () => clearInterval(counter);
    }
  }, [winAmount]);

  useEffect(() => {
    setSoundEffectFile(totalWinAudioUrl)
  })

  const resultStr = currentAmount.toString(); // Convert result to string
  const images = resultStr.split('').map((char, index) => {
    const isPoint = char === ".";
    return (
      <img
        key={index}
        src={`/${isPoint ? "point" : char}.png`} // Replace `.` with `point.png`
        alt={char}
        className={`w-auto ${isPoint ? "xs:h-3 md:h-5 xl:h-8 2xl:h-10 self-end" : "xs:h-8 md:h-14 xl:h-24 2xl:h-32"}`} // Ensure point.png aligns at the bottom
      />
    );
  });

  return (
    <div className="w-full h-full flex flex-col">
      {/* Win Result Section - Centered Vertically */}
      <div className="flex flex-grow justify-center items-center">
        <div
          className="flex justify-center items-center bg-center bg-no-repeat"
          style={{
            backgroundImage: "url('/win-result-bg.png')",
            backgroundSize: "100% 100%",
            width: "100%", // Ensures full width
            height: "80%", // Adjust as needed
          }}
        >
          <div className="flex items-end">{images}</div> {/* Align all images to the bottom */}
        </div>
      </div>

      {/* Bottom Section - Stuck to Bottom */}
      {/* <div
        className="absolute bottom-0 w-full bg-center bg-no-repeat bg-cover flex items-center justify-center xs:text-lg md:text-2xl xl:text-4xl 2xl:text-6xl"
        style={{
          backgroundImage: "url('/result-bg.png')",
          backgroundSize: "100% 130%",
          height: "20%", // Adjust height as needed
        }}
      >
        You won {currentAmount} with {winLines} lines.
      </div> */}
    </div>
  );
};

export default WinResult;
